import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, LogOut, ChevronLeft, ChevronRight, BarChart, Image, ShieldCheck } from 'lucide-react';
import LogoutModal from './LogoutModal';

interface SidebarProps {
  isCollapsed: boolean;
  onToggle: () => void;
}

export default function Sidebar({ isCollapsed, onToggle }: SidebarProps) {
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

  return (
    <div className={`${isCollapsed ? 'w-16' : 'w-64'} bg-white dark:bg-gray-800 shadow-lg h-full transition-all duration-300 relative`}>
      <button
        onClick={onToggle}
        className="absolute -right-3 top-6 bg-white dark:bg-gray-700 rounded-full p-1 border dark:border-gray-600 shadow-md hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors duration-200"
      >
        {isCollapsed ? (
          <ChevronRight className="w-4 h-4 dark:text-gray-200" />
        ) : (
          <ChevronLeft className="w-4 h-4 dark:text-gray-200" />
        )}
      </button>
      <div className="p-4">
        <h1 className={`text-2xl font-bold text-gray-800 dark:text-white truncate ${isCollapsed ? 'text-center px-2' : ''}`}>
          {isCollapsed ? 'E' : 'Epson'}
        </h1>
      </div>
      <nav className="mt-6 flex flex-col">
        <NavLink
          to="/dashboard"
          className={({ isActive }) =>
            `flex items-center ${isCollapsed ? 'justify-center px-4' : 'px-6'} py-3 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 ${
              isActive ? 'bg-gray-100 dark:bg-gray-700' : ''
            } transition-colors duration-200`
          }
        >
          <LayoutDashboard className={`w-5 h-5 ${isCollapsed ? '' : 'mr-3'}`} />
          {!isCollapsed && 'Dashboard'}
        </NavLink>
        <NavLink
          to="/campaign-balance"
          className={({ isActive }) =>
            `flex items-center ${isCollapsed ? 'justify-center px-4' : 'px-6'} py-3 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 ${
              isActive ? 'bg-gray-100 dark:bg-gray-700' : ''
            } transition-colors duration-200`
          }
        >
          <BarChart className={`w-5 h-5 ${isCollapsed ? '' : 'mr-3'}`} />
          {!isCollapsed && 'Campaign Balance'}
        </NavLink>
        <NavLink
          to="/banners"
          className={({ isActive }) =>
            `flex items-center ${isCollapsed ? 'justify-center px-4' : 'px-6'} py-3 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 ${
              isActive ? 'bg-gray-100 dark:bg-gray-700' : ''
            } transition-colors duration-200`
          }
        >
          <Image className={`w-5 h-5 ${isCollapsed ? '' : 'mr-3'}`} />
          {!isCollapsed && 'Banners'}
        </NavLink>
        <NavLink
          to="/security"
          className={({ isActive }) =>
            `flex items-center ${isCollapsed ? 'justify-center px-4' : 'px-6'} py-3 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 ${
              isActive ? 'bg-gray-100 dark:bg-gray-700' : ''
            } transition-colors duration-200`
          }
        >
          <ShieldCheck className={`w-5 h-5 ${isCollapsed ? '' : 'mr-3'}`} />
          {!isCollapsed && 'Security'}
        </NavLink>
        <button
          onClick={() => setIsLogoutModalOpen(true)}
          className={`w-full flex items-center ${isCollapsed ? 'justify-center px-4' : 'px-6'} py-3 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200`}
        >
          <LogOut className={`w-5 h-5 ${isCollapsed ? '' : 'mr-3'}`} />
          {!isCollapsed && 'Logout'}
        </button>
      </nav>
      
      <LogoutModal 
        isOpen={isLogoutModalOpen} 
        onClose={() => setIsLogoutModalOpen(false)} 
      />
    </div>
  );
}
